module.exports = __webpack_public_path__ + "assets/img/report-act-bg-1.01537f14.png";